var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgReadmore3(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    "data-name": "Layer 2",
    xmlns: "http://www.w3.org/2000/svg",
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_383",
    "data-name": "Rectangle 383",
    width: 26,
    height: 26,
    rx: 5,
    fill: "#c9befc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1252",
    "data-name": "Path 1252",
    d: "M113.28,231.05l3.614,2.6,7.469-.9.172-.616Z",
    transform: "translate(-107.683 -219.099)",
    fill: "#ded9ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1253",
    "data-name": "Path 1253",
    d: "M123.978,126.483l-1.478.2-2.442.325-2.247.3-1.982.265c-.749.1-1.5.2-2.247.3-.3.038-.3.029-.3.334v4.743l15.118-6.473L113.29,120c0,.063-.008.107-.008.151q0,2.362,0,4.724c0,.123.03.161.159.177.945.119,1.888.252,2.833.378.889.118,1.778.232,2.666.35.8.107,1.609.219,2.413.326s1.61.213,2.414.319c.07.009.139.023.208.034Z",
    transform: "translate(-107.683 -113.071)",
    fill: "#6b3bed"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReadmore3);
export default __webpack_public_path__ + "static/media/readmore3.fd4ef141809efcb5dcc65a4b634a313c.svg";
export { ForwardRef as ReactComponent };